var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "route-login" },
    [
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "content-holder" }, [
          _vm._m(0),
          _c("h1", [_vm._v("Wachtwoord opnieuw instellen")]),
          _c("span", { staticClass: "subtitle" }, [
            _vm._v(
              "Je huidige wachtwoord is verlopen, je moet daarom een nieuw wachtwoord instellen."
            ),
          ]),
          _c(
            "form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.submit.apply(null, arguments)
                },
              },
            },
            [
              _c("cms-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                attrs: {
                  type: "password",
                  name: "oldPassword",
                  placeholder: "Huidig wachtwoord",
                  "data-vv-as": "Huidig wachtwoord",
                  error: _vm.error("oldPassword"),
                },
                model: {
                  value: _vm.oldPassword,
                  callback: function ($$v) {
                    _vm.oldPassword = $$v
                  },
                  expression: "oldPassword",
                },
              }),
              _c("cms-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                attrs: {
                  type: "password",
                  name: "newPassword",
                  placeholder: "Nieuw wachtwoord",
                  "data-vv-as": "Nieuw wachtwoord",
                  error: _vm.error("newPassword"),
                },
                model: {
                  value: _vm.newPassword,
                  callback: function ($$v) {
                    _vm.newPassword = $$v
                  },
                  expression: "newPassword",
                },
              }),
              _c("cms-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                attrs: {
                  type: "password",
                  name: "newPasswordConfirm",
                  placeholder: "Nieuw wachtwoord herhalen",
                  "data-vv-as": "Herhaalde wachtwoord",
                  error: _vm.error("newPasswordConfirm"),
                },
                model: {
                  value: _vm.newPasswordConfirm,
                  callback: function ($$v) {
                    _vm.newPasswordConfirm = $$v
                  },
                  expression: "newPasswordConfirm",
                },
              }),
              _c(
                "cms-button",
                {
                  attrs: { loading: _vm.submitting },
                  on: { click: _vm.submit },
                },
                [_vm._v("Inloggen")]
              ),
              _c("input", {
                staticStyle: { display: "none" },
                attrs: { type: "submit" },
              }),
            ],
            1
          ),
        ]),
      ]),
      _c("toast-container"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "logos-holder" }, [
      _c("div", { staticClass: "logo" }, [
        _c("i", { staticClass: "img logo-aveco-color-180" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }